/** Centralized data-testid registry for CostIQ. */
export const TID = {
    // Auth
    loginEmail: "login-email-input",
    loginPassword: "login-password-input",
    loginSubmit: "login-submit-btn",
    loginError: "login-error-msg",
    loginQuickFill: (role) => `login-quickfill-${role.toLowerCase()}`,

    // Layout
    sidebar: "app-sidebar",
    sidebarLogo: "sidebar-logo",
    sidebarItem: (key) => `nav-item-${key}`,
    headerUserMenu: "header-user-menu",
    headerLogout: "header-logout-btn",
    headerPlantScope: "header-plant-scope",

    // Dashboard
    dashboard: "dashboard-page",
    kpiTile: (k) => `kpi-${k}`,
    kpiValue: (k) => `kpi-${k}-value`,

    // Foundation
    plantsPage: "plants-page",
    plantsAddBtn: "plants-add-btn",
    plantsTable: "plants-table",
    plantRow: (id) => `plant-row-${id}`,

    gradesPage: "steel-grades-page",
    gradesAddBtn: "grades-add-btn",
    gradesTable: "steel-grades-table",
    gradeRow: (id) => `grade-row-${id}`,
    gradeUpdateRateBtn: (id) => `grade-update-rate-${id}`,

    scrapPage: "scrap-rates-page",
    scrapAddBtn: "scrap-add-btn",
    scrapTable: "scrap-table",

    machinesPage: "machines-page",
    machinesAddBtn: "machines-add-btn",
    machinesTable: "machines-table",

    machineRatesPage: "machine-rates-page",
    machineRatesAddBtn: "machine-rates-add-btn",
    machineRatesTable: "machine-rates-table",
    machineRateSubmit: (id) => `machine-rate-submit-${id}`,
    machineRateApprove: (id) => `machine-rate-approve-${id}`,

    processRatesPage: "process-rates-page",
    processRatesAddBtn: "process-rates-add-btn",
    processRatesTable: "process-rates-table",
    conversionOpsPage: "conversion-ops-page",
    conversionOpsAddBtn: "conversion-ops-add-btn",
    conversionOpsTable: "conversion-ops-table",

    customersPage: "customers-page",
    customersAddBtn: "customers-add-btn",
    customersTable: "customers-table",

    suppliersPage: "suppliers-page",
    suppliersAddBtn: "suppliers-add-btn",
    suppliersTable: "suppliers-table",
    supplierRow: (id) => `supplier-row-${id}`,

    // Stub modules
    zbcPage: "zbc-page",
    rfqPage: "rfq-page",
    settlementPage: "settlement-page",
    supplierQuotesPage: "supplier-quotes-page",
    usersPage: "users-page",

    // Modal dialogs
    modalSubmit: "modal-submit-btn",
    modalCancel: "modal-cancel-btn",
    modalClose: "modal-close-btn",
};

export default TID;
